import { jsx as o } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { ButtonLink as f } from "@kds-web/button";
import { ArrowRightIcon as s } from "@kds-web/icons";
import m from "clsx";
const c = n(function({ label: r, targetId: i, className: t, ...a }, e) {
  return /* @__PURE__ */ o(
    f,
    {
      ref: e,
      variant: "secondary",
      iconRight: /* @__PURE__ */ o(s, {}),
      label: r,
      href: `#${i}`,
      className: m(
        "absolute left-large scale-0 focus:scale-100 [&:not(:hover)]:!bg-surface",
        t
      ),
      ...a
    }
  );
});
c.displayName = "SkipLink";
export {
  c as SkipLink,
  c as default
};
